import { forwardRef } from "react";

import dynamic from "next/dynamic";

import { DashboardHeadlessRichTextInputSsrProps } from "@/dashboard-design-system/RichTextInput/DashboardHeadlessRichTextInputSsr";

// Disabled SSR to avoid memory leak caused by styled
const DynamicDashboardHeadlessRichTextInput = dynamic(
  () => import("./DashboardHeadlessRichTextInputSsr").then((mod) => mod.DashboardHeadlessRichTextInputSsr),
  { ssr: false }
);

export type DashboardHeadlessRichTextInputProps = Omit<DashboardHeadlessRichTextInputSsrProps, "forwardedRef">;

// Wrap dynamic component with forwardRef and pass ref as forwardedRef prop
// This is necessary because next/dynamic doesn't properly forward refs
export const DashboardHeadlessRichTextInput = forwardRef<HTMLDivElement, DashboardHeadlessRichTextInputProps>(
  (props, ref) => <DynamicDashboardHeadlessRichTextInput {...props} forwardedRef={ref} />
);

DashboardHeadlessRichTextInput.displayName = "DashboardHeadlessRichTextInput";
